import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../../styles/admins/rooms/adv_book_history.css";
import AdvanceRoomCard from "../../generals/adv_room_card";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import roomImg from "../../../../images/room.jpg";
import { Link } from "react-router-dom";

const imgStyles = {
  width: "100%",
  height: "100px",
  objectFit: "cover",
  border: "1px solid white",
      borderRadius: "15px 15px 0px 0px",
};

const buttonStyles = {
  backgroundColor: "#007bff",
  border: "none",
  color: "#fff",
  padding: "6px 16px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "1rem",
  fontWeight: "600",
};

const editButton = {
  backgroundColor: "#008800",
  border: "none",
  color: "#fff",
  padding: "6.5px 8px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "0.95rem",
  fontWeight: "600",
};

const cardBodyStyles = {
  padding: "0px 0px 15px 0px",
    // background: "linear-gradient(0deg, rgb(36, 39, 46) 0%, rgba(17, 0, 32, .5) 100%)",
    backgroundColor: 'white',
    borderRadius: "15px",
    margin: '10px 0px',
    textAlign: 'center'
};

const cardTitleStyles = {
  fontSize: "1.25rem",
  margin: "0",
  // color: 'white',
  fontWeight: "bold",
};

const AdvanceBookingHistory = (props) => {
  const [bookings, setBookings] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [showNormal, setShowNormal] = useState(false);
  const [invNo, setInvNo] = useState(null);
    const [roomType, setRoomType] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedBook, setSelectedBook] = useState('');

  const navigate = useNavigate();

      useEffect(() => {
      axios
        .get(`https://api.dectwinhotel.com/api/get-self/${props.id}`)
        .then((response) => {
const fetchedInvNo = response.data[0].inv_no;
// console.log(fetchedInvNo);
setInvNo(fetchedInvNo);
// console.log(response.data[0]);
      localStorage.removeItem("client_is");
localStorage.setItem("client_is", JSON.stringify(response.data[0]));

        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            window.location.reload();
          }
          console.error("Error fetching products:", error);
        });
  }, [props.id]);


  // Fetch booking details if room is booked in advance
  useEffect(() => {
    if (!props.id) return;
    const storedRooms = localStorage.getItem("rooms");
    axios
      .get(
        `https://api.dectwinhotel.com/api/${props.id}_advance_bookings/advance-history`
      )
      .then((response) => {
  console.log("Bookings fetched:", response.data);
          setBookings(response.data);
      })
      .catch((error) => {
        console.error("Error fetching booking details:", error);
      });
    if (storedRooms) {
            const myrooms = JSON.parse(storedRooms);

      // Use cached data if available
     const uniqueTypes = [
          ...new Set(
            myrooms.map(room => room.room_type.trim().toLowerCase())
          )
        ];

      setRoomType(uniqueTypes);
      setRooms(myrooms);
    } else {
      // Fetch products from the API
      axios
        .get(`https://api.dectwinhotel.com/api/${props.id}_rooms/rooms`)
        .then((response) => {
          // Store products in localStorage
          localStorage.setItem("rooms", JSON.stringify(response.data));
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
        });
    }
  }, [props.id]);

  // Handle check-in creation for a specific booking
  const handleCancel = async (booking) => {
    props.handleLoading();
    await axios.put(
      `https://api.dectwinhotel.com/api/${props.id}_advance_bookings/cancel-booking/${booking.advance_booking_id}`
    );
    navigate("/admin/dashboard");
    props.closeLoading();
  };

  const handleCheckIn = async (booking) => {
    // console.log(booking);
    props.handleLoading();
    try {
const updatedBooking = {
      ...booking,
      inv_no: invNo,
      live_image: null,
      live_image_file: null,
      source: "Walk In",
      from_location: 'NA',
      to_location: 'NA'
    };      // booking.live_image = null;
      // booking.live_image_file = null;
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${props.id}_bookings/checkin-room`,
        updatedBooking,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      props.closeLoading();
      if (response.status === 201) {
        props.handleToast({
          toastMsg: "Check In Successfully!!!",
          toastColor: "#4CAF50",
        });
        await axios.put(
          `https://api.dectwinhotel.com/api/${props.id}_advance_bookings/success-booking/${booking.advance_booking_id}`
        );

          const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);
        clientDetails.inv_no = clientDetails.inv_no + 1;

        localStorage.removeItem("rooms");
        navigate("/admin/dashboard");
        localStorage.removeItem("client_is");
        localStorage.setItem("client_is", JSON.stringify(clientDetails));
        // navigate("/admin/rooms");
      } else {
        props.handleToast({
          toastMsg: "Something went wrong! Please check data or internet.",
          toastColor: "#FF0000",
        });
      }
    } catch (err) {
      console.log(err);
      props.closeLoading();
    }
  };


    const handleOpenModal = (books) => {
const matchedRoom = rooms.find((r) => r.room_id === books.room_id);

  setSelectedBook({
    ...books,
    room_type: matchedRoom ? matchedRoom.room_type : null,
  });      // setSelectedBook(books);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
      setSelectedBook('');
    setModalOpen(false);
  };


  return (
    <>
    <section
      style={{
        backgroundColor: "#282c34",
        padding: "1rem",
        minHeight: "90vh",
      }}
    >
      <div className="advance-bookings-section">
        <h2>Advance Booking History</h2>
        <div className="d-flex justify-content-between mb-3">
          {showNormal ? (
            <div></div>
          ) : (
            <div className="date-picker-adv">
              Pick A Date : &nbsp;
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </div>
          )}
          <button
            style={{ backgroundColor: "#0000ff" }}
            className="fetch-btn"
            onClick={() => setShowNormal(!showNormal)}
          >
            {showNormal ? "View Calender" : "Recent Bookings"}
          </button>
        </div>

        {!showNormal && (
<div className="row">
    {roomType.map((type, index) => {
      const roomsOfType = rooms.filter(room => room.room_type.toLowerCase() == type);

  const availableRooms = roomsOfType.filter((room) => {
    const roomBookings = bookings.filter((b) => b.room_id === room.room_id);
    const isBooked = roomBookings.some((booking) => {
      // if (booking.booking_status === "cancelled") return false;
      const fromDate = new Date(booking.from_date);
      const toDate = new Date(booking.to_date);
      const selected = new Date(startDate);
      selected.setHours(0, 0, 0, 0);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(0, 0, 0, 0);

      return (
        selected >= fromDate &&
        selected <= toDate &&
        (booking.booking_status === "pending" ||
          booking.booking_status != "cancelled" ||
          booking.booking_status === "confirmed")
      );
    });
    return !isBooked;
  });

  // if (availableRooms.length === 0) return null;

  const firstAvailableRoom = availableRooms[0];

console.log(firstAvailableRoom);

    return (
      <div className="col-lg-3 col-md-6 col-6">
        <div style={cardBodyStyles}>
                        <img src={roomImg} alt="Card top" style={imgStyles} />
          
                  <h5 className="my-3" style={cardTitleStyles}>{type.charAt(0).toUpperCase() + type.slice(1)} ({roomsOfType.length})</h5>

<p className="text-warning">({availableRooms.length} Available)</p>

{availableRooms.length <= 0 ? 
  <button onClick={() => props.handleToast({
        toastMsg: "Bookings Full. No Rooms Available in this Category.",
        toastColor: "#FF0000",
      })} style={editButton} className="bg-danger">Booking Full</button>        
  : (
    <div className="my-2">
    <Link
          className="room-type-btn"
style={editButton}          to="/admin/book-advance"
          state={firstAvailableRoom}
        >
          Book Now
        </Link>
        </div>
)}

      </div>
      </div>
    )})}
</div>
        )}


{showNormal && bookings.length > 0 && (
          <div className="table-responsive">
            <table className="reports-table">
              <thead>
                <tr>
                  <th>Booking ID</th>
                  <th>Guest Name</th>
                  <th>Room Type</th>
                  <th>Check-in Date</th>
                  <th>Check-out Date</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((books) => (
                  <tr key={books.booking_id}>
                    <td>ADV{books.advance_booking_id}</td>
                    <td>{JSON.parse(books.guest_ids).name[0]}</td>
                    {/* <td>{books.room_no}</td> */}
<td>
  {(() => {
    const matchedRoom = rooms.find(r => r.room_id === books.room_id);
    return matchedRoom ? matchedRoom.room_type : "N/A";
  })()}
</td>
                    <td>{new Date(books.from_date).toLocaleString()}</td>
                    <td>{new Date(books.to_date).toLocaleString()}</td>
                    <td>₹{books.total_amount}</td>
                    <td>
                      <div className="d-flex justify-content-around align-items-center">
                        {books.booking_status === "pending" ? (
                          <>
                          {books.room_no == null ? 
                            <button
                              style={buttonStyles}
                              onClick={() => {
                                handleOpenModal(books);
                              }}
                            >
                              Assign
                            </button>
                                                      :
                            <button
                              style={buttonStyles}
                              onClick={() => {
                                handleCheckIn(books);
                              }}
                            >
                              Checkin
                            </button>
}

                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <button
                              style={{
                                ...editButton,
                                backgroundColor: "#FF0000",
                              }}
                              onClick={() => {
                                handleCancel(books);
                              }}
                            >
                              &nbsp;&nbsp;&nbsp;Cancel&nbsp;&nbsp;&nbsp;
                            </button>
                          </>
                        ) : (
                          <button
                            style={{
                              ...editButton,
                              backgroundColor:
                                books.booking_status === "cancelled"
                                  ? "#ff0000"
                                  : "#008800",
                              color: "white",
                            }}
                          >
                            {books.booking_status.toUpperCase()}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/*         {!showNormal && (
          <div className="advance-bookings-cards">
            {rooms.length > 0 ? (
              rooms.map((room) => (
                <AdvanceRoomCard
                  key={room.room_id}
                  id={props.id}
                  roomData={{ ...room, booking_id: bookings.length + 1 }}
                  bookingData={bookings.filter((elm) => {
                    return elm.room_id === room.room_id;
                  })}
                  handleCancel={handleCancel}
                  handleCheckIn={handleCheckIn}
                  today={startDate}
                />
              ))
            ) : (
              <div className="no-rooms-message">
                <i
                  style={{
                    fontSize: "6rem",
                    margin: "30px 10px",
                    color: "black",
                  }}
                  className="fa fa-bed"
                ></i>
                <p>No Advance Bookings done yet.</p>
              </div>
            )}
          </div>
        )} */}
      </div>
    </section>

{isModalOpen && (
  <div className="modal-backdrop col-lg-8">
    <div className="modals">
      {/* Close button */}
      <button className="close-button" onClick={handleCloseModal}>
        &times;
      </button>

      <div className="text-center px-3 mt-1">
        <h4 style={{ fontWeight: "600", color: "black" }}>
          Assign {selectedBook.room_type} Room to Booking ID {selectedBook.advance_booking_id}
        </h4>

        {/* Dropdown for available rooms (same type only) */}
        <select
          className="form-select mt-3"
          style={{ width: "80%", margin: "0 auto" }}
          value={selectedBook.new_room_id || ""}
onChange={(e) => {
    const selectedRoom = rooms.find(
      (r) => r.room_id === parseInt(e.target.value)
    );
    setSelectedBook((prev) => ({
      ...prev,
      // room_id: selectedRoom?.room_id || null,
      new_room_id: selectedRoom?.room_id || null,
      new_room_number: selectedRoom?.room_number || "",
    }));
  }}       >
          <option value="">-- Select Available Room --</option>
          {rooms
            .filter((room) => {
                const sameType =
                  room.room_type?.toLowerCase() ===
                  selectedBook.room_type?.toLowerCase();
                  console.log(sameType);
                if (!sameType) return false;

              const roomBookings = bookings.filter(
                (b) => b.room_no == room.room_number
              );
              const isBooked = roomBookings.some((booking) => {
if (booking.booking_status === "cancelled") return false;
        const fromDate = new Date(booking.from_date);
        const toDate = new Date(booking.to_date);
        const selectedFrom = new Date(selectedBook.from_date);
        const selectedTo = new Date(selectedBook.to_date);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);
        selectedFrom.setHours(0, 0, 0, 0);
        selectedTo.setHours(0, 0, 0, 0);

 return (
          ((selectedFrom >= fromDate && selectedFrom <= toDate) ||
            (selectedTo >= fromDate && selectedTo <= toDate) ||
            (selectedFrom <= fromDate && selectedTo >= toDate)) &&
          (booking.booking_status === "pending" ||
            booking.booking_status === "confirmed")
        );
      });
              return !isBooked;
            })
            .map((room) => (
              <option key={room.room_id} value={room.room_id}>
                Room No {room.room_number} — {room.room_type}
              </option>
            ))}
        </select>

        <button
          className="book-button mt-4"
          onClick={async () => {
            if (!selectedBook.room_id) {
              props.handleToast({
                toastMsg: "Please select a room first!",
                toastColor: "#FF0000",
              });
              return;
            }

            // console.log("Booking ID:", selectedBook.advance_booking_id);
// console.log("Table name prefix:", props.id);

            try {
              props.handleLoading();
              await axios.put(
                `https://api.dectwinhotel.com/api/${props.id}_advance_bookings/assign-room/${selectedBook.advance_booking_id}`,
                { new_room_id: selectedBook.new_room_id, new_room_number: selectedBook.new_room_number }
              );


await handleCheckIn(selectedBook);

              props.closeLoading();
              props.handleToast({
                toastMsg: "Room assigned successfully!",
                toastColor: "#4CAF50",
              });

              // Refresh bookings
              const response = await axios.get(
                `https://api.dectwinhotel.com/api/${props.id}_advance_bookings/advance-history`
              );
              setBookings(response.data);

              handleCloseModal();
            } catch (error) {
              props.closeLoading();
              console.error("Error assigning room:", error);
              props.handleToast({
                toastMsg: "Failed to assign room. Try again.",
                toastColor: "#FF0000",
              });
            }
          }}
        >
          Check In Now
        </button>
      </div>
    </div>
  </div>
)}



</>
  );
};

export default AdvanceBookingHistory;
